import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    {
        path: '/help/',
        name: 'help',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.h1.read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import('@/router/views/help/')
    },

    {
        path: '/contactus/',
        name: 'Contact Us',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.cu1.read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import('@/router/views/contactus/')
    },
]